import { Component } from '@angular/core';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Notification } from '../../../../core/models/notification.model';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent {

  constructor(
    public notificationService: NotificationService
  ){}

  ngOnInit(): void {
    this.notificationService.getNotifications().subscribe({
      next:()=>{
        if(this.notificationService.isOutage()){
          window.location.href = '/scheduled-maintenance';
        }
      }
    });
  }

  remove(index:number){
    this.notificationService.notifications.splice(index,1);
  }
}
